// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { footerContainerStyles } from "@conklin/Overrides/Widgets/Footer/FooterContainer";
import { DivWrapper } from "@conklin/XDL/constants";
import { color, layoutContainer, xScreen } from "@conklin/XDL/Utilities";
import { StyledButton } from "@insite/mobius/Clickable";
import { StyledTypography } from "@insite/mobius/Link";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

footerContainerStyles.widgetGridContainer = {
    css: css`
        background-color: ${color("common.ui6")};
        padding: 20px 0 16px 0;
        display: flex;
        flex-direction: column;
        row-gap: 16px;

        ${({ isCheckoutPage }: any) =>
            !isCheckoutPage &&
            css`
                border-top: 4px solid ${color("primary")};
            `}

        &&& {
            .list-wrapper ${StyledButton}:not(:disabled) {
                &,
                &:hover {
                    ${StyledTypography} {
                        color: ${color("common.ui1")};
                    }
                    &.list-link {
                        ${StyledTypography} {
                            color: ${color("common.ui3")};
                        }
                    }
                }
                &:hover {
                    ${StyledTypography} {
                        text-decoration: underline;
                    }
                }
            }
        }

        ${xScreen("lte", "md")} {
            padding-top: 24px;
        }
    `,
};

footerContainerStyles.topSection = {
    css: css`
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        column-gap: 22px;
        ${layoutContainer}
        ${xScreen("lte", "md")} {
            grid-template-columns: minmax(0, 1fr);
            row-gap: 24px;
        }
    `,
};

footerContainerStyles.topLeftSection = {
    css: css`
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 24px 22px;

        ${xScreen("lte", "md")} {
            column-gap: 20px;
        }

        ${xScreen("lte", "sm")} {
            grid-template-columns: repeat(2, minmax(0, 1fr));
            column-gap: 24px;
        }
    `,
};

footerContainerStyles.topRightSection = {
    css: css`
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px 22px;

        ${xScreen("lte", "md")} {
            column-gap: 20px;
        }

        ${xScreen("lte", "sm")} {
            grid-template-columns: minmax(0, 1fr);
        }
    `,
};

footerContainerStyles.awards = {
    css: css`
        display: flex;
        flex-direction: column;
        background-color: ${color("common.ui7")};
        border-radius: 4px;
        padding: 12px;
    `,
};

footerContainerStyles.awardsImages = {
    css: css`
        width: 100%;
        ${DivWrapper} {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 12px 28px;
        }
    `,
};

footerContainerStyles.locationsSection = {
    css: css`
        padding: 12px;
        margin: 12px 0 4px;
        background-color: ${color("common.ui7")};
        text-align: center;
        width: 100%;
        box-shadow: 0 -3px 0 ${color("common.ui6")}, 0px -4px 0 ${color("common.ui5")}, 0 3px 0 ${color("common.ui6")},
            0px 4px 0 ${color("common.ui5")};
        > ${DivWrapper} {
            ${layoutContainer};
            display: flex;
            justify-content: center;

            .links-wrapper {
                flex-wrap: wrap;
                padding: 0px 220px;
                justify-content: center;
                gap: 8px 12px;

                ${xScreen("lte", "md")} {
                    padding: 0 12px;
                }

                ${xScreen("lte", "sm")} {
                    padding: 0;
                }
            }
        }
    `,
};

footerContainerStyles.botttomSection = {
    css: css`
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px 16px;
        ${layoutContainer}
        width: 100%;

        .list-wrapper {
            float: right;
        }

        ${xScreen("lte", "sm")} {
            grid-template-columns: minmax(0, 1fr);
            justify-items: center;
            width: unset;

            .list-wrapper {
                float: left;
            }
        }
    `,
};

footerContainerStyles.copyrightText = {
    size: 12,
    lineHeight: "17px",
    color: "common.ui1",
    css: css`
        line-height: 17px;
    `,
};

footerContainerStyles.socialLinks = {
    css: css`
        ${({ isAuthenticated }: any) => {
            return isAuthenticated
                ? css`
                      [data-test-selector="spacer-widget"] {
                          display: none;
                      }
                  `
                : null;
        }}
        ${xScreen("lte", "xs")} {
            ${TypographyStyle} {
                text-align: center;
            }
            .social-links {
                justify-content: center;
            }
        }
    `,
};
